import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import "./resultPopUp.scss";
import {
  selectPickResultDates,
  selectPickResultTime,
} from "../../../redux/3d_game_Slice/gameinfo3d";
import { SocketState } from "../../../context/SocketProvider";
import ModalContainer from "../../../2d-game/modals/ModalContainer";

function ResultPopup3d() {
  let navigate = useNavigate();
  const ResultDates = useSelector(selectPickResultDates);
  const ResultTime = useSelector(selectPickResultTime);
  const { socket } = SocketState();

  const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"));
  const container = useRef(null);

  useEffect(() => {
    showResult();
  }, [fromDate]);

  let showResult = () => {
    let payload = {
      en: "PICK_THREE_RESULTS_HISTORY",
      data: { date: moment(fromDate, "YYYY-MM-DD").format("DD-MM-YYYY") },
    };
    socket.emit("req", payload);
  };

  console.log(ResultTime);

  return (
    <ModalContainer title={"Result"} navigation={"/3d"}>
      <div className="myaccount_content">
        {/* Date Filter Section */}
        <div className="date_search_section flex items-center">
          <div className="w-full flex">
            <div className="w-1/4 px-4">
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-bold mb-2"
                  htmlFor="from"
                >
                  From
                </label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="from"
                  type="date"
                  placeholder="from"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  max={moment().format("YYYY-MM-DD")}
                  min={"2023-04-01"}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div
          className="history_table_div h-[calc(100vh-35vh)] overflow-y-auto pb-16"
          ref={container}
        >
          <table className="table table-borderless history_table">
            <thead className="sticky top-0">
              <tr>
                <th className="text-center">TIME</th>
                {ResultDates.length > 0 &&
                  ResultDates.map((date, index) => (
                    <th key={index} className="text-center">
                      {date}
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody>
              {ResultDates.length ? (
                Object.keys(ResultTime)
                  .filter((timeArray) => {
        // remove rows having "--"
        return !ResultTime[timeArray].some(
          (v) => v && v.trim() === "--"
        );
      })
      .sort((a, b) => {
        // latest time first
        return (
          moment(b, "hh:mm:ss A").valueOf() -
          moment(a, "hh:mm:ss A").valueOf()
        );
      })
                  .map((timeArray, timeArrayIndex) => (
                    <tr key={timeArrayIndex}>
                      <td className="text-center">{timeArray}</td>

                      {ResultTime[timeArray].map((value, valueIndex) => (
                        <td key={valueIndex}>
                          <div className="result_his_line">
                            {value &&
                            value.trim() !== "--" &&
                            value.trim() !== " -- " ? (
                              value.includes("&") ? (
                                value.split("&").map((pair, idx) => {
                                  const parts = pair.split("=");

                                  return (
                                    <div
                                      key={idx}
                                      className={`result_span_10_series text-center three_game_result_his${
                                        idx + 1
                                      }`}
                                    >
                                      {parts[0]} - {parts[1] || ""}
                                    </div>
                                  );
                                })
                              ) : (
                                (() => {
                                  const parts = value.split("=");

                                  return (
                                    <div className="result_span_10_series text-center">
                                      {parts[1] || value}
                                    </div>
                                  );
                                })()
                              )
                            ) : (
                              ""
                            )}
                          </div>
                        </td>
                      ))}
                    </tr>
                  ))
              ) : (
                <tr>
                  <td className="text-center">-</td>
                  <td colSpan={7} className="text-center">
                    No result Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </ModalContainer>
  );
}

export default ResultPopup3d;
